export const config = {
  androidLink:
    process.env.REACT_APP_ANDROID_LINK || "https://play.google.com/store/apps/details?id=com.filaracosmomobile",
  iosLink: process.env.REACT_APP_IOS_LINK || "https://apps.apple.com/ru/app/filaracosmo/id6443695296",
  androidAppName: 'filaracosmomobile',
  iosAppName: 'filaracosmomobile'
};
